import * as React from 'react'
import Button from 'components/Button'
import SimpleTable from 'components/Tables/SimpleTable'
import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import { dispatchToProps } from './VoiceCreateQuoteStep.container'
import { sum } from 'lodash'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import { keyValArrayToObject } from '../../../utils/lodash'

export interface IVoiceCreateQuoteStepComponentProps {
  submitting: boolean
  prev: () => void
  price: number
  loading: boolean
  getQuote: typeof dispatchToProps['getQuote']
  formData: any
  setHeadings?: Function
}

export class VoiceCreateQuoteStepComponent extends React.Component<
  IVoiceCreateQuoteStepComponentProps
> {
  componentWillMount() {
    const { getQuote, formData } = this.props
    getQuote({ script: keyValArrayToObject(formData.script) as any, talentID: formData.talentID })
  }
  render() {
    const { submitting, prev, price, formData, loading, setHeadings } = this.props

    setHeadings &&
      setHeadings({
        heading: 'Your business just sounds better, well it will!',
        subHeading:
          "If you're happy to proceed, all you need to do is submit your order and we'll put your chosen Voice Actor to work. Your Script Recording will be made available to you in the Pickle Portal under Voice Actors Recordings.",
      })

    return (
      <div>
        <div className={cn(sText.descrip2, sMarg.mb30)}>
          You're almost done. Check out the quote below. If you are happy, click 'Finish' and we'll
          send the details through to your chosen voice actor.
        </div>
        <div style={{ position: 'relative' }}>
          {loading && <LoadingOverlay />}
          <SimpleTable>
            <div>
              <div>Total Files:</div>
              <div>{formData.script.length}</div>
            </div>
            <div>
              <div>Total Script Length:</div>
              <div>{sum(formData.script.map(script => script.value.split(' ').length))} words</div>
            </div>
            <div>
              <div>Turnaround time:</div>
              <div>approx 3 days</div>
            </div>
            <div>
              <div>Total Cost:</div>
              <div>
                <b>${price}</b> ex GST
              </div>
            </div>
          </SimpleTable>
        </div>
        <div className={cn(sText.descrip4, sMarg.mt30)}>
          We'll let you know when your recording is complete.
        </div>
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button color="tertiary" type="submit" loading={submitting}>
            Finish
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateQuoteStep/VoiceCreateQuoteStep.tsx